import { Outlet } from "react-router-dom";

const ProgramAssignLayout = () => {
  return <Outlet />;
};

export default ProgramAssignLayout;